import { FC } from "react"
import SectionCell from "../../../../../section/cell"
import {
  EXCLUDED_MISC_DETAILS,
  MISC_FIELD_LABELS,
  MISC_FIELD_VALUES
} from "../../../../../../constants"
import { Lead } from "../../../../../../../types"

interface Props {
  data: Lead
  cols: number
}

const Misc: FC<Props> = ({ data, cols }) => {
  const { details } = data

  return (
    <div className={`grid grid-cols-${cols} gap-4`}>
      {/* Render all other fields */}
      {Object.entries(details).map(([key, value]) => {
        if (EXCLUDED_MISC_DETAILS.includes(key) || key === "quote_id")
          return null

        if (value === null || value === undefined) return null
        if (typeof value === "object") return null

        const stringValue = `${value}`
        if (stringValue === "") return null

        const label =
          MISC_FIELD_LABELS[key] ??
          key.replace(/_/g, " ").replace(/^./, (c: string) => c.toUpperCase())

        const valueLabel =
          key === "parent_url" || typeof value !== "string"
            ? stringValue
            : MISC_FIELD_VALUES[key]?.[stringValue] ??
              stringValue
                .replace(/_/g, " ")
                .replace(/^./, (c: string) => c.toUpperCase())

        return (
          <SectionCell
            key={key}
            truncateValue={key === "parent_url"}
            className={`!pt-0 break-all ${
              key === "parent_url" ? "row-span-2" : ""
            }`}
            label={label}
            value={valueLabel}
            h={"min-h-[1.75rem] h-auto"}
          />
        )
      })}

      {/* Always render quote_id */}
      <SectionCell
        key="quote_id"
        truncateValue={false}
        className="!pt-0 break-all"
        label="Quote id"
        value={details.quote_id ? String(details.quote_id) : "No Quote"}
        h={"min-h-[1.75rem] h-auto"}
      />
    </div>
  )
}

export default Misc
